export class Address {
    addressLine1: string;
    addressLine2: string;
    suite: string;
    city: string;
    state: string;
    zipCode: string;
    fullName: string;
    lastName: string;
    zipPlus4: string;
}
